export default [
  {
    id: 'edit-scheme',
    text: 'Edit',
    icon: 'mdi-pencil',
    _enabled: true
  },
  {
    id: 'export-json',
    text: 'Export as JSON',
    icon: 'mdi-download',
    _enabled: true
  },
  {
    id: 'change-group-access',
    text: 'Change access',
    icon: 'mdi-security',
    _enabled: true
  },
  {
    id: 'enable-disable',
    text: '',
    icon: 'mdi-cancel',
    _enabled: true
  },
  {
    id: 'bump-version',
    text: 'Bump version',
    icon: 'mdi-numeric-positive-1',
    _enabled: true
  },
  {
    id: 'copy-uuid',
    text: 'Copy UUID',
    icon: 'mdi-content-copy',
    _enabled: true
  },
  {
    id: 'duplicate-schema',
    text: 'Duplicate schema',
    icon: 'mdi-content-copy',
    _enabled: true
  },
  {
    id: 'delete',
    text: 'Delete',
    icon: 'mdi-delete',
    _enabled: true
  }
];
